import Constants from './Constants.js'
import SelectionReducer from './SelectionReducer.js'

/**
 * Sets the configuration of the group and clears it if its changed.
 */
function config( group, config ) {
  return { type : Constants.SELECTION_CONFIG, group, config }
}

/**
 * Adds the item to the group's selection list. 
 */
function add( group, items ) {
  return { type : Constants.SELECTION_ADD, group, items }
}

/**
 * Replaces the group's current selection with the given items.
 */
function set( group, items ) {
  return { type : Constants.SELECTION_SET, group, items }
}

/**
 * Removes the items from the group's current selection.
 * @param {string} group the name of the selection group
 * @param {string|number|Array<string|number>} items the items or ids to remove. 
 * Can be one or an array
 */
function remove( group, items ) {
  return { type : Constants.SELECTION_REMOVE, group, items }
}

/**
 * Clears the group's current selection.
 */
function clear( group ) {
  return { type : Constants.SELECTION_CLEAR, group }
}

function pop( group ) {
  return { type : Constants.SELECTION_POP, group }
}

/**
 * Clears all groups.
 */
function clearAll( group ) {
  return { type : Constants.SELECTION_CLEAR_ALL }
}

function group( group ) {
  return {
    config : cfg => config( group, cfg ),
    add : items => add( group, items ),
    set : items => set( group, items ),
    remove : items => remove( group, items ),
    clear : ( ) => clear( group ),
    pop : () => pop( group )
  }
}

// Not 'good practice' to put accessors in action generator
// but it is less confusing for the user and reads better,
// and the selector are still really owned by the redcuer and only
// advertised here
const get = SelectionReducer.get
const getIds = SelectionReducer.getIds
const getSelected = SelectionReducer.getSelected
const isSelected = SelectionReducer.isSelected
const count = SelectionReducer.count
const isEmpty = SelectionReducer.isEmpty
const addHook = SelectionReducer.addHook
const removeHook = SelectionReducer.removeHook
const hookRemoveFromAll = SelectionReducer.hookRemoveFromAll

export default {
  config,
  add,
  set,
  remove,
  clear,
  clearAll,
  group,
  pop,
  get,
  getIds,
  getSelected,
  isSelected,
  count,
  isEmpty,
  addHook,
  removeHook,
  hookRemoveFromAll
}
